exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-100[data-v-4dee13fa] {\n  width: 100%;\n}\n[data-v-4dee13fa] .md-title {\n  padding: 0;\n}\n.custom-padding[data-v-4dee13fa] {\n  padding-right: 56px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4dee13fa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/navigation/LymitDialog.vue
// module id = HkG6
// module chunks = 1